import * as Yup from "yup";

type TFunction = (key: string) => string;

export const getLoginSchema = (t: TFunction) =>
  Yup.object({
    login: Yup.string()
      .transform((value) => value?.toLowerCase().trim())
      .required(t("enterLoginOrEmail"))
      .min(3, t("loginTooShort")),
    password: Yup.string().required(t("enterPassword")),
  });

export const getRegisterSchema = (t: TFunction) =>
  Yup.object({
    nickname: Yup.string()
      .min(2, t("tooShort"))
      .max(20, t("tooLong"))
      .required(t("enterNickname")),
    email: Yup.string()
      .transform((value) => value?.toLowerCase().trim())
      .email(t("invalidEmailFormat"))
      .required(t("enterEmail")),
    telegramId: Yup.string()
      .transform((value) => value?.trim())
      .matches(/^[0-9]+$/, t("telegramIdMustBeNumber"))
      .min(5, t("telegramIdTooShort"))
      .max(15, t("telegramIdTooLong"))
      .required(t("telegramIdRequired")),
    password: Yup.string()
      .min(6, t("atLeast6"))
      .required(t("enterPassword")),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], t("passwordsDontMatch"))
      .required(t("confirmPassword")),
  });

export const getForgotPasswordStep1Schema = (t: TFunction) =>
  Yup.object({
    login: Yup.string()
      .transform((value) => value?.toLowerCase().trim())
      .required(t("enterLoginOrEmail"))
      .min(3, t("loginTooShort")),
  });

export const getForgotPasswordStep2Schema = (t: TFunction) =>
  Yup.object({
    code: Yup.string()
      .transform((value) => value?.trim())
      .required(t("codeRequired"))
      .min(4, t("codeTooShort")),
  });

export const getFormPageSchema = (t: TFunction) =>
  Yup.object({
    username: Yup.string()
      .transform((value) => value?.trim())
      .required(t("fieldRequired")),
    bio: Yup.string()
      .transform((value) => value?.trim())
      .required(t("fieldRequired")),
  });

export const getAddRowSchema = (
  t: TFunction,
  columns: string[],
  columnTypes?: Record<string, string>
) => {
  const SYSTEM_FIELDS = ["id", "created_at", "updated_at"];

  const shape = columns
    .filter(col => !SYSTEM_FIELDS.includes(col))
    .reduce((acc, col) => {
      acc[col] = Yup.string().required(t("fieldRequired"));
      return acc;
    }, {} as Record<string, Yup.Schema>);

  return Yup.object().shape(shape);
};

export type LoginFormValues = Yup.InferType<
  ReturnType<typeof getLoginSchema>
>;
export type RegisterFormValues = Yup.InferType<
  ReturnType<typeof getRegisterSchema>
>;
export type ForgotPasswordStep1FormValues = Yup.InferType<
  ReturnType<typeof getForgotPasswordStep1Schema>
>;
export type ForgotPasswordStep2FormValues = Yup.InferType<
  ReturnType<typeof getForgotPasswordStep2Schema>
>;
